// Type
import type { AxiosInstance } from "axios"
import type { SuccessFetch } from "types"

export function getSourceDetail(
  api: AxiosInstance,
  data_source_id?: string
): Promise<number> {
  return new Promise<number>((resolve, reject) => {
    api.get(
      "/proreject/get_id_receive_reject",
      { params: { datasource_id: data_source_id } }
    ).then((res: SuccessFetch<{
      payload: { reject_id: number }
    }>) => {
      resolve(res.data.payload.reject_id)
    }).catch(() => {
      reject(0)
    })
  })
}